module.exports = __webpack_public_path__ + "static/media/brainbay-logo.2140e77e.svg";